import { useModal } from '@/lib/ModalContext';
import styles from './Footer.module.css';

export default function Footer() {
  const { setOpen } = useModal();
  return (
    <footer className={styles.foot}>
      <div className="container">
        <div className={styles.grid}>
          <div className={styles.col}>
            <h4>AVOWAL</h4>
            <p className={styles.brandText}>
              Attorney-backed legal services, intelligently managed. Patent-pending AI legal operations
              architecture. Successor platform to A.R. Pro Se Strategic Operations.
            </p>
          </div>
          <div className={styles.col}>
            <h4>Product</h4>
            <a href="#what">What it is</a>
            <a href="#how">How it works</a>
            <a href="#platforms">Platforms</a>
            <a href="#elaria">ELARIA</a>
          </div>
          <div className={styles.col}>
            <h4>Trust</h4>
            <a href="#trust">Ethics &amp; UPL</a>
            <a href="#" onClick={(e) => { e.preventDefault(); setOpen('waitlist'); }}>Attorney inquiries</a>
            <a href="#">Press kit</a>
            <a href="#">Patent status</a>
          </div>
          <div className={styles.col}>
            <h4>Contact</h4>
            <a href="mailto:hello@avowal.ai">hello@avowal.ai</a>
            <a href="mailto:attorneys@avowal.ai">attorneys@avowal.ai</a>
            <a href="mailto:press@avowal.ai">press@avowal.ai</a>
          </div>
        </div>
        <div className={styles.disclaimer}>
          <p>
            AVOWAL is a technology platform. AVOWAL is not a law firm and does not provide legal advice.
            Legal services are provided exclusively by independent attorneys licensed in the relevant
            jurisdiction. Use of AVOWAL does not create an attorney-client relationship with AVOWAL itself.
          </p>
          <p>
            ELARIA is an AI agent providing legal operations support (document preparation, citation
            verification, workflow management). ELARIA does not provide legal advice and is not a substitute
            for counsel. All substantive legal judgment is rendered by the licensed attorney engaged through
            the platform.
          </p>
          <p>
            Patent pending. Provisional applications do not confer enforceable patent rights until and
            unless a non-provisional application matures to grant.
          </p>
          <div className={styles.copyright}>
            <span>&copy; 2026 AVOWAL &middot; A2BE Inc.</span>
            <span>avowal.ai &middot; avowal.law &middot; avowal.legal &middot; avowal.io</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
